import React from "react";
import Main from "../components/custom/Main";
import PageContainer from "../components/custom/PageContainer";
import "../styles/Dashboard.css";
import { useSelector } from "react-redux";
import { StoreState } from "../redux/reducers";

const Dashboard: React.FC = () => {
  const authUsers = useSelector((state: StoreState) => state.authUser);

  return (
    <Main>
      <PageContainer title={`Welcome !`}>
        <div></div>
      </PageContainer>
    </Main>
  );
};

export default Dashboard;
